var map = {
	"./175.png": 67218,
	"./USA.png": 60037,
	"./afganistan.png": 54140,
	"./albaania.png": 76034,
	"./alzeeria.png": 45715,
	"./andorra.png": 21792,
	"./angola.png": 56579,
	"./antigua ja barbuda.png": 78804,
	"./araabia ühend emiraadid.png": 66606,
	"./argentiina.png": 77661,
	"./armeenia.png": 22462,
	"./aserbaitsaan.png": 93588,
	"./austraalia.png": 22097,
	"./austria.png": 68004,
	"./bahama.png": 29370,
	"./bahrein.png": 55042,
	"./bangadesh.png": 87644,
	"./barbados.png": 60290,
	"./belau.png": 1456,
	"./belgia.png": 68300,
	"./belize.png": 81859,
	"./benin.png": 99010,
	"./bhutan.png": 60176,
	"./boliivia.png": 15835,
	"./bosnia ja hertsegoviina.png": 22119,
	"./botswana.png": 83409,
	"./brasiilia.png": 16626,
	"./brunei.png": 79418,
	"./bulgaaria.png": 15419,
	"./burkina faso.png": 7989,
	"./burundi.png": 98518,
	"./cabo verde.png": 88637,
	"./costa rica.png": 90570,
	"./cote divoire.png": 43254,
	"./djibouti.png": 11641,
	"./dominica.png": 51036,
	"./dominikaani vabariik.png": 40869,
	"./eSwatiini.png": 33125,
	"./eesti.png": 91922,
	"./egiptus.png": 38716,
	"./ekvatoriaal guinea.png": 12074,
	"./el-salvador.png": 62112,
	"./equador.png": 88338,
	"./eritrea.png": 4768,
	"./etioopia.png": 58680,
	"./fiji.png": 36037,
	"./filipiinid.png": 16504,
	"./gabon.png": 81239,
	"./gambija.png": 14970,
	"./ghana.png": 93949,
	"./grenada.png": 48765,
	"./gruusia.png": 97350,
	"./guatemaala.png": 57852,
	"./guinea bissau.png": 84507,
	"./guinea.png": 45050,
	"./guynea.png": 51649,
	"./haiti.png": 86487,
	"./hiina.png": 28531,
	"./hispania.png": 21207,
	"./holland.png": 50149,
	"./honduras.png": 65872,
	"./horvaatia.png": 9487,
	"./ida timor.png": 34053,
	"./iirimaa.png": 79662,
	"./india.png": 31790,
	"./indoneesia.png": 72014,
	"./iraak.png": 77601,
	"./iraan.png": 60010,
	"./island.png": 93108,
	"./israel.png": 46055,
	"./itaalia.png": 64990,
	"./jaapan.png": 22077,
	"./jamaica.png": 49652,
	"./jeemen.png": 9914,
	"./jordaania.png": 90678,
	"./kambodsa.png": 72868,
	"./kamerun.png": 11393,
	"./kanada.png": 54813,
	"./kasastan.png": 56939,
	"./katar.png": 73123,
	"./keenia.png": 89169,
	"./kesk aafrika vabariik.png": 44486,
	"./kiribati.png": 43881,
	"./kolumbia.png": 20200,
	"./komoorid.png": 12521,
	"./kongo demokraatlik vabariik.png": 13740,
	"./kongo vabariik.png": 69900,
	"./kosovo.png": 70860,
	"./kreeka.png": 88694,
	"./kuuba.png": 86016,
	"./kuveit.png": 5749,
	"./kõrgõstan.png": 82677,
	"./küpros.png": 48127,
	"./laos.png": 43978,
	"./leedu.png": 95130,
	"./lesotho.png": 15688,
	"./libeeria.png": 83819,
	"./liibanon.png": 47579,
	"./liibüa.png": 86612,
	"./litsenstein.png": 67512,
	"./luxembourg.png": 36186,
	"./läti.png": 1087,
	"./lõuna aafrika vabariik.png": 28488,
	"./lõuna korea.png": 22011,
	"./lõuna sudaan.png": 19734,
	"./madagaskar.png": 66242,
	"./malaisia.png": 25749,
	"./malawi.png": 20469,
	"./maldiivid.png": 86164,
	"./mali.png": 75102,
	"./malta.png": 99110,
	"./marokko.png": 5954,
	"./marshalli saared.png": 76546,
	"./mauritaania.png": 51063,
	"./mauritius.png": 69850,
	"./mehiko.png": 16124,
	"./mikroneesia.png": 85415,
	"./moldova.png": 42095,
	"./monaco.png": 72617,
	"./mongoolia.png": 98335,
	"./montenegro.png": 34289,
	"./mosambiik.png": 11922,
	"./myanmar.png": 84041,
	"./namiibia.png": 95313,
	"./nauru.png": 32401,
	"./nepal.png": 51204,
	"./nigeeria.png": 61040,
	"./niger.png": 26239,
	"./nikaragua.png": 2737,
	"./norra.png": 85002,
	"./omaan.png": 61929,
	"./paapua uus quiana.png": 33207,
	"./pakistan.png": 59045,
	"./panama.png": 27883,
	"./paraguay.png": 72142,
	"./peruu.png": 84951,
	"./poola.png": 34539,
	"./portugal.png": 90590,
	"./prantsusmaa.png": 91521,
	"./põhja korea.png": 21070,
	"./põhja makedoonia.png": 89919,
	"./rootsi.png": 9615,
	"./rumeenia.png": 39115,
	"./rwanda.png": 11971,
	"./saalomoni saared.png": 15090,
	"./saint lucia.png": 51121,
	"./saint vincent ja grenadiinid.png": 45264,
	"./saksamaa.png": 87714,
	"./sambia.png": 68758,
	"./samoa.png": 3723,
	"./san marino.png": 6108,
	"./sao tome ja principe.png": 74199,
	"./saudi araabia.png": 4591,
	"./seishellid.png": 6501,
	"./senegal.png": 66493,
	"./serbia.png": 52725,
	"./singapur.png": 36956,
	"./sirra leone.png": 49818,
	"./slovakkia.png": 47101,
	"./sloveenia.png": 64427,
	"./somaalia.png": 1949,
	"./soome.png": 12276,
	"./sri lanka.png": 76025,
	"./st kitts ja newis.png": 9243,
	"./sudaan.png": 69883,
	"./suriname.png": 97960,
	"./suurbritania.png": 44074,
	"./sveits.png": 75502,
	"./süüria.png": 47996,
	"./taani.png": 48409,
	"./tai.png": 57354,
	"./tajikistan.png": 77754,
	"./tansaania.png": 88355,
	"./togo.png": 76677,
	"./trinidad ja tobago.png": 12769,
	"./tsaad.png": 75139,
	"./tsehhi.png": 87672,
	"./tsiili.png": 11772,
	"./tuneesia.png": 32393,
	"./tuvalu.png": 8767,
	"./türgi.png": 16301,
	"./türkmenistan.png": 46486,
	"./uganda.png": 81192,
	"./ukraina.png": 30522,
	"./ungari.png": 86230,
	"./uruguay.png": 97231,
	"./uspekistan.png": 33819,
	"./uus meremaa.png": 1696,
	"./valgevene.png": 27274,
	"./vanuatu.png": 4945,
	"./vatikan.png": 44555,
	"./venemaa.png": 74686,
	"./venezuela.png": 46053,
	"./vietnam.png": 40459,
	"./zimbabe.png": 2011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72638;